/* eslint-disable @typescript-eslint/no-explicit-any */
import { generateSEO } from "@/helpers/seo";
import { resolveTranslatedPath } from "@/lib/i18n/functions";
import { getData } from "@/lib/prismic/data";
import { InspirationDocument, PageDocument } from "@/prismicio-types";
import { notFound, redirect } from "next/navigation";
import { use } from "react";

const Inspiration = ({ resolution }: TemplateProps) => {
  console.log("HHHHE");

  const document = use(
    getData({
      ...resolution,
      templateName: "inspiration",
    })
  ) as InspirationDocument;

  console.log("Document : ", document);

  if (!document || !document.data) return notFound();

  const parent = document.data?.categories?.[0]?.inspirationCategory as any;

  if (parent) {
    // Rewrite URL
    const newURL = resolveTranslatedPath({ id: "string", uid: parent.uid, type: parent.type, lang: parent.lang });

    return redirect(`${newURL}#${document.uid}`);
  }

  return notFound();

  // console.log("Parent : ", parent);

  // return (
  //   <main id="main">
  //     <h1>Inspiration : {document.data?.title || ""}</h1>
  //   </main>
  // );
};

export default Inspiration;

Inspiration.generateMetadata = async (resolution: any) => {
  const document = (await getData({
    ...resolution,
    templateName: "inspiration",
  })) as PageDocument;

  if (!document || !document.data) {
    return {};
  }

  return generateSEO(document, resolution.locale);
};
